import React from "react"

import { Button } from "../ui/button"

const ErrorMessage: React.FC = () => {
  const handleRetry = () => {
    window.location.reload()
  }

  return (
    // TODO improve error massage with potentially more info, a retry button etc.
    <div className={"flex h-full w-full items-center justify-center"}>
      <div className={"flex flex-col items-center gap-2"}>
        <p className={"text-2xl font-semibold text-danger-primary"}>An unexpected error occurred</p>
        <p className={"text-sm text-danger-primary"}>
          We apologize for the inconvenience and are working to resolve the issue
        </p>
        <Button onClick={handleRetry} className="mt-4 px-6 py-2">
          Retry
        </Button>
      </div>
    </div>
  )
}

export default ErrorMessage
